// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GooglePlusCircleFilledSvg from "@ant-design/icons-svg/es/asn/GooglePlusCircleFilled";
import AntdIcon from '../components/AntdIcon';

var GooglePlusCircleFilled = function GooglePlusCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: GooglePlusCircleFilledSvg
  }));
};

GooglePlusCircleFilled.displayName = 'GooglePlusCircleFilled';
export default React.forwardRef(GooglePlusCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/GooglePlusCircleFilled.js
// module id = 1283
// module chunks = 0